
import { Base } from '../base-component';

import './infographic-page-center.component.scss';

export class InfographicPageCenter extends Base {

	constructor(element: Element){

		super(element)
				
	}

	init(){}
		
	bindEvents(){}

}




// WEBPACK FOOTER //
// ./components/infographic-page-center/infographic-page-center.component.ts